import React, { FC } from 'react';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { dashboardService, transactionService } from '../../../../../channels/secure-web/services';
import { PartyIdentification } from '../../../../card/src/types';
import { AppLoader } from '../../../../content-composer/src/components/Generic/AppLoader';
import { AppError } from '../../../../content-composer/src/components/Generic/AppError';
import { PartyRelationship } from '../../../../userProfile/src/domain/UserInfo/entities/PostLoginCardResponseDTO';
import { CardHeaders } from '../../../../userProfile/src/domain/UserInfo/entities';
import { useSelectedCustomerId } from '../../../../userProfile/src/contexts/UserInfo/hooks';
import { ParametersContext } from './ParametersContext';

const ParametersProvider: FC = ({ children }) => {
  const selectedCustomerId = useSelectedCustomerId();
  const {
    data: transactionStatusesData,
    error: transactionStatusesError,
    isLoading: isLoadingTransactionStatuses,
  } = useInvokeSWRService(
    transactionService.GetTransactionStatuses,
    {},
    true,
    'transactionService.GetTransactionStatuses',
  );

  const {
    data: transactionTypesData,
    error: transactionTypesError,
    isLoading: isLoadingTransactionTypes,
  } = useInvokeSWRService(transactionService.GetTransactionTypes, {}, true, 'transactionService.GetTransactionTypes');

  const {
    data: orderStatusesData,
    error: orderStatusesError,
    isLoading: isLoadingOrderStatuses,
  } = useInvokeSWRService(transactionService.GetOrderStatuses, {}, true, 'transactionService.GetOrderStatuses');

  const {
    data: postLoginCardData,
    isLoading: isLoadingPostLoginCardData,
    error: postLoginCardDataError,
  } = useInvokeSWRService<{
    cardHeaders: CardHeaders;
    selectedPartyIdentifier?: PartyIdentification;
    partyRelationships?: PartyRelationship[];
  }>(dashboardService.PostLoginCard, { customerId: selectedCustomerId }, true, 'dashboardService.PostLoginCard');

  return (
    <ParametersContext.Provider
      value={{
        transactionStatusesData,
        transactionTypesData,
        orderStatusesData,
        postLoginCardData,
      }}>
      {(isLoadingTransactionStatuses ||
        isLoadingTransactionTypes ||
        isLoadingOrderStatuses ||
        isLoadingPostLoginCardData) && <AppLoader />}
      {(transactionStatusesError || transactionTypesError || orderStatusesError || postLoginCardDataError) && (
        <AppError
          fullHeight
          message={
            transactionStatusesError?.message ||
            transactionTypesError?.message ||
            orderStatusesError?.message ||
            postLoginCardDataError?.message
          }
          code={
            transactionStatusesError?.code ||
            transactionTypesError?.code ||
            orderStatusesError?.code ||
            postLoginCardDataError?.code
          }
          shouldShowButton={false}
        />
      )}
      {transactionStatusesData && transactionTypesData && orderStatusesData && postLoginCardData && children}
    </ParametersContext.Provider>
  );
};

export { ParametersProvider };
